<template>
  <div class="shares-units">
    <label class="label shares-units__label">
      Number of shares is in
    </label>
    <b-radio
    v-model="localIsSharesPercentage"
    :native-value="true">
    %
    </b-radio>
    <b-radio
    v-model="localIsSharesPercentage"
    :native-value="false">
    units
    </b-radio>
  </div>
</template>

<script>
export default {
  name: 'SharesUnits',
  props: ['value'],
  data () {
    return {
      localIsSharesPercentage: this.value
    }
  },
  watch: {
    isSharesPercentage () {
      this.localIsSharesPercentage = this.value
    },
    localIsSharesPercentage () {
      this.$emit('input', this.localIsSharesPercentage)
    }
  }
}
</script>

<style scoped>
  .shares-units {
    display: flex;
  }

  .shares-units__label {
    margin-bottom: 0;
    margin-right: 0.5em;
  }
</style>
